var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5.00195C18 6.65881 16.6569 8.00195 15 8.00195C14.0585 8.00195 13.2183 7.56824 12.6683 6.8897L7.84194 9.03852C7.94443 9.34092 8 9.66497 8 10.002C8 10.2258 7.97549 10.4439 7.929 10.6538L12.9696 12.7934C13.5039 12.302 14.2169 12.0019 15 12.0019C16.6569 12.0019 18 13.3451 18 15.0019C18 16.6588 16.6569 18.0019 15 18.0019C13.3432 18.0019 12 16.6588 12 15.0019C12 14.7131 12.0408 14.4339 12.117 14.1696L7.17253 12.0708C6.6261 12.6445 5.8548 13.002 5 13.002C3.34315 13.002 2 11.6588 2 10.002C2 8.34514 3.34315 7.00199 5 7.00199C5.73064 7.00199 6.40028 7.26319 6.92063 7.6973L12.0293 5.42278C12.01 5.28527 12 5.14478 12 5.00195C12 3.3451 13.3432 2.00195 15 2.00195C16.6569 2.00195 18 3.3451 18 5.00195Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.9b9a311cd2d64ade1af5528f528ad514.svg";
export { ForwardRef as ReactComponent };